/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { IMediaModel } from "@nf/common";
import { RouteHelper } from "helpers/routeHelper";
import { useTranslation } from "next-i18next";

import Button from "components/Button";
import { useSyncCompleted } from "hooks";

import TrailerIcon from "resources/icons/trailer.svg";

interface TrailerButtonProps {
  media: IMediaModel;
}

const TrailerButton = ({ media }: TrailerButtonProps) => {
  const { t } = useTranslation("translations");
  const isAuthProcessCompleted = useSyncCompleted();

  return (
    <Button
      href={RouteHelper.goToTrial(media.Id)}
      icon={<TrailerIcon />}
      variant="secondary"
      state={isAuthProcessCompleted ? "default" : "skeleton"}
    >
      {t("web_asset_page_watch_trailer")}
    </Button>
  );
};

export default TrailerButton;
